<template>
  <div>
    <router-link v-if="!isMobile && !isSmallScreen" :to="{name: 'mesAccueils'}" class="back-link" title="Retour à mes accueils"><font-awesome-icon :icon="['fas', 'arrow-left']" size="2x" /><span class="sr-only">Retour à mes accueils</span></router-link>
    <EbHeading v-if="(!isMobile && !isSmallScreen) && enfant" level="h1" class="eb-page-heading">Fiche de {{ enfant.nom }} {{ enfant.prenom }}</EbHeading>
    <div class="eb-content-default">
      <EbBanner :isActive="error" type="error" title="Une erreur est survenue" @removeBanner="error=false" :timestamp="bannerTimestamp">Veuillez réessayer ultérieurement.</EbBanner>

      <div v-if="enfant">
        <div class="md:flex md:justify-between md:align-items-center">
          <EbEtiquette type="theme">Accueil en cours</EbEtiquette>
          <div>
            <EbLinkButton v-if="!isMobile" :to="{name: 'ficheEnfantModify', params: {idEnfant: Number(enfant.id)}}" class="secondary">Modifier</EbLinkButton>
            <EbLinkButton v-if="!isMobile" :to="{name: 'ficheEnfantDelete', params: {idEnfant: Number(enfant.id)}}" class="primary">Déclarer la fin de l’accueil</EbLinkButton>
          </div>
        </div>

        <div class="text-center">
          <font-awesome-icon :icon="['fas', 'baby']" size="2x" class="eb-site-color" />
          <EbHeading level="h2" class="eb-box-heading-large">
            <span class="text-uppercase">{{ enfant.nom }}</span> {{ enfant.prenom }}
          </EbHeading>
          <ul>
            <li>Date de naissance : <time :datetime="enfant.dateNaissance">{{ getLongDate(enfant.dateNaissance) }}</time></li>
            <li>Date de la déclaration : <strong><time :datetime="enfant.dateDeclaration">{{ getLongDate(enfant.dateDeclaration) }}</time></strong></li>
            <li>Date d’arrivée de l’enfant : <strong><time :datetime="enfant.dateArrivee">{{ getLongDate(enfant.dateArrivee) }}</time></strong></li>
          </ul>
        </div>
        <div v-if="isMobile" class="eb-button-group">
          <EbLinkButton :to="{name: 'ficheEnfantModify', params: {idEnfant: Number(enfant.id)}}" class="secondary expanded">Modifier</EbLinkButton>
          <EbLinkButton :to="{name: 'ficheEnfantDelete', params: {idEnfant: Number(enfant.id)}}" class="primary expanded">Déclarer la fin de l’accueil</EbLinkButton>
        </div>

        <hr />

        <div v-if="enfant.parentsEnfant">
          <EbHeading level="h3" class="eb-box-heading">Informations sur les parents</EbHeading>
          <div v-if="enfant.parentsEnfant" class="md:flex md:justify-between md:align-items-start">
            <div class="md:flex w50 mt-24">
              <font-awesome-icon :icon="['fas', 'baby']" size="3x" class="mr-20 eb-site-color" />
              <p>
                <strong>
                  <span class="text-uppercase">{{ enfant.parentsEnfant[0].nom }}</span> {{ enfant.parentsEnfant[0].prenom }}
                </strong>
                <br />
                <span>{{ enfant.parentsEnfant[0].adresse }}<br /></span>
                {{ enfant.parentsEnfant[0].telephone }}
              </p>
            </div>
            <div v-if="enfant.parentsEnfant[1].nom" class="md:flex w50 mt-24">
              <font-awesome-icon :icon="['fas', 'baby']" size="3x" class="mr-20 eb-site-color" />
              <p>
                <strong>
                  <span class="text-uppercase">{{ enfant.parentsEnfant[1].nom }}</span> {{ enfant.parentsEnfant[1].prenom }}
                </strong>
                <br />
                <span>{{ enfant.parentsEnfant[1].adresse }}<br /></span>
                {{ enfant.parentsEnfant[1].telephone }}
              </p>
            </div>
          </div>
        </div>

        <hr />

        <div v-if="enfant.modaliteAccueilEnfant">
          <EbHeading level="h3" class="eb-box-heading">Modalités d’accueil</EbHeading>
          <div class="flex">
            <ul class="eb-list-check">
              <li v-if="enfant.modaliteAccueilEnfant.accueilJournee">Toute la journée</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilMatin">Matin</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilApresMidi">Après-midi</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilMidi">Midi</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilMercredi">Mercredi</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilMatinAvantEcole">Matin avant l’école</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilSoirApresEcole">Soir après l’école</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilVacancesScolaires">Vacances scolaires</li>
              <li v-if="enfant.modaliteAccueilEnfant.accueilAutre">Autres modalités : {{ enfant.modaliteAccueilEnfant.accueilAutre }}</li>
            </ul>
            <p v-if="enfant.modaliteAccueilEnfant.commentaire">
              Commentaire : <br /><b>{{ enfant.modaliteAccueilEnfant.commentaire }}</b>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ficheEnfant',
  props: {
    idEnfant: {
      default: null,
    },
    bannerTimestamp: ''
  },
  data() {
    return {
      enfant: null,
      error: false,
    }
  },
  mounted() {
    if (this.idEnfant != null) this.getEnfant()
  },
  methods: {
    getEnfant: async function() {
      await this.$http
        .get('assmat/enfants/' + this.idEnfant)
        .then(resp => {
          this.enfant = resp.data
          this.error = false
        })
        .catch(error => {
          this.error = true
          this.bannerTimestamp = this.getTime()
        })
    },
  },
}
</script>
